'use client';
import { motion } from 'framer-motion';
import { useRef } from 'react';

interface CardBodyProps {
  selectedInfoCard: number | null;
  cardId: number;
  cardBody: React.ReactElement;
}

export default function CardBody({
  cardBody,
  cardId,
  selectedInfoCard,
}: CardBodyProps) {
  const isSelected = selectedInfoCard === cardId;
  const ref = useRef<HTMLDivElement>(null);
  const scrollHeight = ref.current?.scrollHeight || 0;

  return (
    <div style={{ maxHeight: `${scrollHeight}px` }}>
      <motion.div
        id={`${isSelected ? 'selected-' : 'other'}-card-body`}
        ref={ref}
        data-scroll-height={scrollHeight}
        className="overflow-hidden font-['Work_Sans'] text-base leading-[145%] font-normal text-white"
        initial={{ maxHeight: 0, opacity: 0 }}
        animate={{
          maxHeight: isSelected ? `${scrollHeight}px` : 0,
          opacity: isSelected ? 1 : 0,
        }}
        transition={{
          delay: 0.4,
          duration: 1.0,
          ease: [0.4, 0, 0.2, 1],
          opacity: {
            delay: isSelected ? 0.4 : 0.2,
          },
        }}
      >
        <div className="pt-2">{cardBody}</div>
      </motion.div>
    </div>
  );
}
